import { render, staticRenderFns } from "./edit-risk-tip.vue?vue&type=template&id=1bdee77c&"
import script from "./edit-risk-tip.vue?vue&type=script&lang=js&"
export * from "./edit-risk-tip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports